<template>
    <SchedulePanels
        v-bind:protocol="protocol"
        v-bind:cpf="cpf"
        v-bind:cellphone="cellphone"
    ></SchedulePanels>
</template>

<script>
import SchedulePanels from '../components/SchedulePanels'
export default {
    name:'ListarAgendamento',
    props:{
        protocol:{
            type:String
        },
        cpf:{
            type:String
        },
        cellphone:{
            type:String
        }
    },
    components:{SchedulePanels}
}
</script>

<style scoped>

</style>